import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    estado_propietario_runt: null,
    estado_vehiculo_runt: null,
    tiene_multas: null,
    vr_multas: 0,
    unico_dueno: null,
    estado_soat: null,
    vencimiento_soat: null,
    entidad_soat: null,
    estado_tecnicomecanica: null,
    vencimiento_tecnicomecanica: null,
    entidad_tecnicomecanica: null,
    situacion_vehiculo: null,
    valor_pendiente_pagar: 0,
    entidad_bancaria: null,
    impuestos: null,
    liquidacion_impuestos: 0,
    es_blindado: null,
    nivel_blindado: null,
    observaciones: null,
    revision_legal: null
};
const mutations = {
    updateField,
    updateLegal: (state, payload) =>{
        var size = Object.keys(payload.fichatecnica.inspeccion_legal).length;
        if(size > 0){
            var {
                estado_propietario_runt,
                estado_vehiculo_runt,
                tiene_multas,
                vr_multas,
                unico_dueno,
                estado_soat,
                vencimiento_soat,
                entidad_soat,
                estado_tecnicomecanica,
                vencimiento_tecnicomecanica,
                entidad_tecnicomecanica,
                situacion_vehiculo,
                valor_pendiente_pagar,
                entidad_bancaria,
                impuestos,
                liquidacion_impuestos,
                es_blindado,
                nivel_blindado,
                observaciones,
                revision_legal,
            } = payload.fichatecnica.inspeccion_legal;
            state.estado_propietario_runt = estado_propietario_runt;
            state.estado_vehiculo_runt = estado_vehiculo_runt;
            state.tiene_multas = tiene_multas;
            state.vr_multas = vr_multas;
            state.unico_dueno = unico_dueno;
            state.estado_soat = estado_soat;
            state.vencimiento_soat = vencimiento_soat;
            state.entidad_soat = entidad_soat;
            state.estado_tecnicomecanica = estado_tecnicomecanica;
            state.vencimiento_tecnicomecanica = vencimiento_tecnicomecanica;
            state.entidad_tecnicomecanica = entidad_tecnicomecanica;
            state.situacion_vehiculo = situacion_vehiculo;
            state.valor_pendiente_pagar = valor_pendiente_pagar;
            state.entidad_bancaria = entidad_bancaria;
            state.impuestos = impuestos;
            state.liquidacion_impuestos = liquidacion_impuestos;
            state.es_blindado = es_blindado;
            state.nivel_blindado = nivel_blindado;
            state.observaciones = observaciones;
            state.revision_legal = revision_legal;
        }
    }
};

const getters = {
    getField
};

const actions = {

};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}
